// extracted by mini-css-extract-plugin
export default {"price":"price__adSnLs","feature":"feature__yTyAuS","payAsYouGoFeature":"payAsYouGoFeature__o1uaKJ"};